import * as PATHS from 'js/constants/pathnames';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';

import OverviewIcon from 'new/components/icons/OverviewIcon';
import IntegrateIcon from 'new/components/icons/IntegrateIcon';
import { ReactComponent as AIIcon } from 'new/components/icons/sparkles.svg';
import { ReactComponent as TasksIcon } from 'new/components/icons/list-checks.svg';
import DiscoverIcon from 'new/components/icons/DiscoverIcon';
import CollaborateIcon from 'new/components/icons/CollaborateIcon';
import MonitorIcon from 'new/components/icons/MonitorIcon';
import SettingsIcon from 'new/components/icons/SettingsIcon';
import MarketplaceIcon from 'new/components/icons/MarketplaceIcon';

// Integrate icons
import { ReactComponent as FlowIcon } from 'new/components/icons/fi-rr-diagram-subtask.svg';
import { ReactComponent as SourceIcon } from 'new/components/icons/fi-rr-exit.svg';
import { ReactComponent as NexsetIcon } from 'new/components/icons/nexsetsOutline.svg';
import { ReactComponent as DestinationIcon } from 'new/components/icons/fi-rr-arrow-right-to-bracket.svg';
import { ReactComponent as LockIcon } from 'new/components/icons/lock.svg';
import { ReactComponent as LookupsIcon } from 'new/components/icons/table-lookup.svg';
import { ReactComponent as SchemaTemplatesIcon } from 'new/components/icons/fi-rr-layout-fluid.svg';
import { ReactComponent as ProjectsIcon } from 'new/components/icons/folder.svg';
import { ReactComponent as StarIcon } from 'new/components/icons/star.svg';
import { ReactComponent as ReusableTransformsIcon } from 'new/components/icons/fi-rr-recycle.svg';
import { ReactComponent as WindowIcon } from 'new/components/icons/window.svg';

// AI icons
import { ReactComponent as ToolCropIcon } from 'new/components/icons/fi-rr-tool-crop.svg';
import { ReactComponent as ToolIcon } from 'new/components/icons/tool.svg';
import { ReactComponent as PlugConnectorIcon } from 'new/components/icons/plug-connector.svg';
import { ReactComponent as ToolsetIcon } from 'new/components/icons/toolset.svg';
// PlugIcon removed - MCP Servers merged into Toolsets view

// Colaborate Icons
import { ReactComponent as ShareIcon } from 'new/components/icons/share.svg';
import {
  ReactComponent as PeopleIcon,
  ReactComponent as UsersAltIcon,
} from 'new/components/icons/usersAlt.svg';
import { ReactComponent as InsightsIcon } from 'new/components/icons/fi-rr-bulb.svg';

//Monitor icons
import { ReactComponent as BellIcon } from 'new/components/icons/bell.svg';
import { ReactComponent as BellRingIcon } from 'new/components/icons/drawerBellRing.svg';
import { ReactComponent as UtilizationIcon } from 'new/components/icons/fi-rr-stats.svg';
import { ReactComponent as ResourceTriageIcon } from 'new/components/icons/fi-rr-stethoscope.svg';
import { ReactComponent as DailyFlowStatsIcon } from 'new/components/icons/fi-rr-time-twenty-four.svg';
import { ReactComponent as FishIcon } from 'new/components/icons/fish.svg';
import { ReactComponent as FolderDownloadIcon } from 'new/components/icons/folderDownload.svg';
import { ReactComponent as FTPIcon } from 'new/components/icons/ftp.svg';
import { ReactComponent as ListCheckIcon } from 'new/components/icons/listCheck.svg';
import { ReactComponent as DatabaseClock } from 'new/components/icons/fi-rr-database-clock.svg';
import { ReactComponent as PuzzleIcon } from 'new/components/icons/puzzlePiece.svg';
import { ReactComponent as RunIcon } from 'new/components/icons/fi-rr-play-alt.svg';

//Settings icons
import { ReactComponent as UserIcon } from 'new/components/icons/user.svg';
import { ReactComponent as SecurityIcon } from 'new/components/icons/security.svg';
import { ReactComponent as PaletteIcon } from 'new/components/icons/palette.svg';
import { ReactComponent as BuildingIcon } from 'new/components/icons/building.svg';
import { ReactComponent as UsersIcon } from 'new/components/icons/users.svg';
import { ReactComponent as ShieldCheckIcon } from 'new/components/icons/shieldCheck.svg';
import { ReactComponent as ThirdPartyIntegrationsIcon } from 'new/components/icons/fi-rr-plug.svg';
import { ReactComponent as LayersIcon } from 'new/components/icons/layers.svg';
import { ReactComponent as ReceiptIcon } from 'new/components/icons/receipt.svg';
import { ReactComponent as IncognitoIcon } from 'new/components/icons/incognito.svg';
import { AccountBalance as CustomerOrgsIcon, Sell as PlanTiersIcon } from '@mui/icons-material';
import { ReactComponent as NoteBookIcon } from 'new/components/icons/notebook.svg';
import { ReactComponent as PackageIcon } from 'new/components/icons/fi-rr-package.svg';
import { ReactComponent as CapsuleIcon } from 'new/components/icons/capsule.svg';

// Marketplace icons
import { ReactComponent as NexsetListingRequestStar } from 'new/components/icons/NexsetListingRequestStar.svg';
import { ReactComponent as NexsetAccessRequestLock } from 'new/components/icons/NexsetAccessRequestLock.svg';
import { ReactComponent as AppsAddIcon } from 'new/components/icons/fi-rr-apps-add.svg';
import { ReactComponent as GlobeIcon } from 'new/components/icons/fi-rr-globe-alt.svg';
import { ReactComponent as OutlinedSettingsIcon } from 'new/components/icons/settings.svg';

import { DISABLE_DEMO_FEATURES } from 'js/constants/config';
import { getFeatureFlagValue } from 'new/constants/featureFlags';
import React, { FC, ReactNode } from 'react';
import {
  ROUTE_ACCESS_INSIGHTS,
  ROUTE_ACCESS_REQUESTS,
  ROUTE_AI,
  ROUTE_AI_GOVERNANCE,
  ROUTE_AI_RECEIPTS,
  ROUTE_AI_TOOLS,
  ROUTE_AI_TOOL_SETS,
  ROUTE_AI_MCP_FLOWS,
  ROUTE_COLLABORATE,
  ROUTE_CONNECT,
  ROUTE_DATA_CUSTODIANS,
  ROUTE_DATA_DOMAINS,
  ROUTE_SETTINGS_CAPSULES,
  ROUTE_DATA_PRODUCTS,
  ROUTE_DISCOVER,
  ROUTE_LISTING_REQUESTS,
  ROUTE_MARKETPLACE,
  ROUTE_MONITOR,
  ROUTE_PEOPLE_360,
  ROUTE_RESOURCES_360,
  ROUTE_SETTINGS,
  ROUTE_SETTINGS_USER,
  ROUTE_TASKS,
  ROUTE_SQL_AUTOMATIONS,
} from 'new/constants/pathnames';
import { isDemo } from 'new/config';
import { User } from 'new/entities/User';
import { Stack } from '@mui/material';
import { FlowRunsScreen } from 'new/components/monitor/Runs';
import { TMP_DISPLAY_FLOW_RUNS } from 'js/constants/config';
import { shouldShowFeatureBadge } from 'js/constants/featureBadges';
import { FeatureFlagKey } from 'new/constants/featureFlags';

export type StructureItem = {
  title: string | React.ReactNode;
  to?: string;
  onClick?: () => void;
  Icon?: ReactNode;
  BaseComponent?: FC;
  badge?: string;
  isCollapsed?: boolean;
  isDisabled?: boolean;
  featureFlagKey?: FeatureFlagKey;
};

const integrateBasePath = `${ROUTE_REDESIGN}${ROUTE_CONNECT}`;

export type StructureGroup = {
  name?: string;
  badge?: string;
  items: StructureItem[];
  restrictedTiers?: string[];
};

type BaseStructure = {
  name: string;
  to: string;
  Icon: ReactNode;
  restrictedTiers?: string[];
  featureFlagKey?: FeatureFlagKey;
  groups?: (...args: any[]) => StructureGroup[];
};

const styles = {
  titleWithInlineBadgeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inlineBadge: {
    color: 'var(--color-greyscale-400)',
    fontSize: 12,
    fontWeight: 400,
    marginLeft: '32px',
    borderRadius: '4px',
    padding: '2px 4px',
    border: '1px solid var(--color-greyscale-400)',
  },
};

const titleWithInlineBadge = (title: string, badge: string) => {
  return (
    <div style={styles.titleWithInlineBadgeContainer}>
      <div>{title}</div>
      <div style={styles.inlineBadge}>{badge}</div>
    </div>
  );
};

const structure: BaseStructure[] = [
  {
    name: 'Overview',
    Icon: <OverviewIcon />,
    to: ROUTE_REDESIGN,
    restrictedTiers: [],
  },
  {
    name: 'Integrate',
    Icon: <IntegrateIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_CONNECT}`,
    restrictedTiers: [],
    groups: () => [
      {
        name: '',
        restrictedTiers: [],
        items: [
          !DISABLE_DEMO_FEATURES
            ? {
                to: `${integrateBasePath}/projects/starred`,
                Icon: <StarIcon />,
                title: 'Starred',
                restrictedTiers: [],
              }
            : null,
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_PIPELINES}`,
            Icon: <FlowIcon />,
            title: 'All Data Flows',
            restrictedTiers: [],
          },
          {
            to: `${integrateBasePath}/projects`,
            Icon: <ProjectsIcon />,
            title: 'All Projects',
            restrictedTiers: [],
          },
        ].filter(Boolean),
      },
      {
        name: 'Flow Components',
        restrictedTiers: [],
        items: [
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_DATA_SOURCES}`,
            Icon: <SourceIcon />,
            title: 'Sources',
            restrictedTiers: [],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_MY_DATA_SETS}`,
            Icon: <NexsetIcon />,
            title: 'Nexsets',
            restrictedTiers: [],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_DESTINATIONS}`,
            Icon: <DestinationIcon />,
            title: 'Destinations',
            restrictedTiers: [],
          },
        ],
      },
      {
        name: 'Common Components',
        restrictedTiers: [],
        items: [
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_CREDENTIALS}`,
            Icon: <LockIcon />,
            title: 'Credentials',
            restrictedTiers: [],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_DATA_MAPS}`,
            Icon: <LookupsIcon />,
            title: 'Lookups',
            restrictedTiers: ['express_tiers'],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_SCHEMA_SPECS}`,
            Icon: <SchemaTemplatesIcon />,
            title: 'Schema Templates',
            restrictedTiers: ['express_tiers'],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_REUSABLE_TRANSFORMS}`,
            Icon: <ReusableTransformsIcon />,
            title: 'Reusable Transforms',
            restrictedTiers: ['express_tiers'],
          },
          {
            to: `${integrateBasePath}${OLD_PATHS.ROUTE_API_KEYS}`,
            Icon: <WindowIcon />,
            title: 'API Keys',
            restrictedTiers: ['express_tiers'],
          },
        ],
      },
    ],
  },
  {
    name: 'AI',
    Icon: <AIIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_AI}`,
    restrictedTiers: [],
    groups: () => [
      {
        name: 'Tools Gateway',
        restrictedTiers: [],
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_AI_TOOL_SETS}`,
            Icon: <ToolsetIcon />,
            title: 'Toolsets & MCP',
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_AI_TOOLS}`,
            Icon: <ToolIcon />,
            title: 'Tools',
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_AI_MCP_FLOWS}`,
            Icon: <FlowIcon />,
            title: 'MCP Flows',
            restrictedTiers: [],
            featureFlagKey: 'UI_ENABLE_MCP_FLOWS',
          },
        ],
      },
    ],
  },
  {
    name: 'Tasks',
    Icon: <TasksIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_TASKS}`,
    restrictedTiers: [],
    groups: () => [
      {
        name: '',
        restrictedTiers: [],
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_SQL_AUTOMATIONS}`,
            Icon: <DatabaseClock />,
            title: 'SQL Automations',
            restrictedTiers: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Discover',
    Icon: <DiscoverIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_DISCOVER}`,
    restrictedTiers: ['express_tiers'],
  },
  {
    name: 'Marketplace',
    Icon: <MarketplaceIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_MARKETPLACE}`,
    restrictedTiers: ['express_tiers'],
    groups: (isDisabled: boolean) => [
      {
        name: '',
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_DATA_PRODUCTS}`,
            title: 'Data Products',
            Icon: <NexsetListingRequestStar />,
            isDisabled: isDisabled,
            restrictedTiers: [],
          },
        ],
      },
      {
        name: 'APPROVAL TASKS',
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_ACCESS_REQUESTS}`,
            title: 'Access Requests',
            Icon: <NexsetAccessRequestLock />,
            isDisabled: isDisabled,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_LISTING_REQUESTS}`,
            title: 'Listing Requests',
            Icon: <AppsAddIcon />,
            isDisabled: isDisabled,
            restrictedTiers: [],
          },
        ],
      },
      {
        name: 'MANAGEMENT',
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_DATA_DOMAINS}`,
            title: 'Data Domains',
            Icon: <GlobeIcon />,
            isDisabled: isDisabled,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_DATA_CUSTODIANS}`,
            title: (
              <Stack direction="row" gap="12px">
                Custodian Settings
                <OutlinedSettingsIcon style={{ fill: 'currentColor' }} />
              </Stack>
            ),
            Icon: <PackageIcon />,
            isDisabled: isDisabled,
            restrictedTiers: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Collaborate',
    Icon: <CollaborateIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE}`,
    restrictedTiers: ['express_tiers', 'self_signup_tiers'],
    groups: () => [
      {
        name: '',
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_ACCESS_INSIGHTS}`,
            Icon: <InsightsIcon />,
            title: 'Access Insights',
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_RESOURCES_360}`,
            Icon: <ShareIcon />,
            title: 'Resources 360°',
            restrictedTiers: [],
          },
          isDemo
            ? {
                to: `${ROUTE_REDESIGN}${ROUTE_PEOPLE_360}`,
                Icon: <PeopleIcon />,
                title: 'People 360°',
                restrictedTiers: [],
              }
            : {
                badge: 'Coming Soon',
                title: 'People 360°',
                Icon: <PeopleIcon />,
                restrictedTiers: [],
              },
        ],
      },
    ],
  },
  {
    name: 'Monitor',
    Icon: <MonitorIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}`,
    restrictedTiers: [],
    groups: () => [
      {
        name: 'Monitoring Options',
        items: [
          ...(TMP_DISPLAY_FLOW_RUNS === true
            ? [
                {
                  to: FlowRunsScreen.screenConfig.path.toString(),
                  title: shouldShowFeatureBadge('FLOW_RUNS')
                    ? titleWithInlineBadge('Runs', 'Beta')
                    : 'Runs',
                  Icon: <RunIcon />,
                  restrictedTiers: [],
                },
              ]
            : []),
          {
            to: `${ROUTE_REDESIGN}/monitor/daily-per-flow-stats`,
            title: 'Data Flow Status',
            Icon: <DailyFlowStatsIcon />,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}/monitor/utilization`,
            title: 'Utilization',
            Icon: <UtilizationIcon />,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}/monitor/resource-triage`,
            title: 'Resource Triage',
            Icon: <ResourceTriageIcon />,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/notifications`,
            title: 'Notifications',
            Icon: <BellIcon />,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/audit`,
            title: 'Audit',
            Icon: <ListCheckIcon />,
            restrictedTiers: ['express_tiers'],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/error-data`,
            title: 'Error Data',
            Icon: <FTPIcon />,
            restrictedTiers: ['express_tiers'],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/record-lineage`,
            title: 'Trace Record Lineage',
            Icon: <FishIcon />,
            restrictedTiers: ['express_tiers'],
          },
        ],
      },
      {
        name: 'SETTINGS',
        items: [
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/notification-settings`,
            title: 'Notification Settings',
            Icon: <BellRingIcon />,
            restrictedTiers: [],
          },
          {
            to: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/error-data-settings`,
            title: 'Error Data Settings',
            Icon: <FolderDownloadIcon />,
            restrictedTiers: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Settings',
    Icon: <SettingsIcon />,
    to: `${ROUTE_REDESIGN}${ROUTE_SETTINGS}`,
    restrictedTiers: [],
    groups(user: User, impersonated: boolean) {
      return [
        {
          name: 'USER PREFERENCES',
          restrictedTiers: [],
          items: [
            {
              to: `${ROUTE_REDESIGN}${ROUTE_SETTINGS_USER}`,
              title: 'User Information',
              Icon: <UserIcon />,
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/security-privacy`,
              title: 'Security & Privacy',
              Icon: <SecurityIcon />,
              restrictedTiers: [],
            },
            isDemo
              ? {
                  to: `#`,
                  title: 'Appearance',
                  badge: 'Admin Only',
                  Icon: <PaletteIcon />,
                  restrictedTiers: [],
                }
              : undefined,
          ],
        },
        {
          name: 'ORGANIZATION SETTINGS',
          restrictedTiers: [],
          items: [
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/organization-info`,
              title: 'Organization Info',
              Icon: <BuildingIcon />,
              restrictedTiers: [],
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/members`,
              title: 'Members',
              Icon: <UsersIcon />,
              restrictedTiers: ['express_tiers'],
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/teams`,
              title: 'Teams',
              Icon: <UsersAltIcon />,
              restrictedTiers: ['express_tiers', 'self_signup_tiers'],
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/data-custodians`,
              title: 'Data Custodians',
              Icon: <PackageIcon />,
              restrictedTiers: ['express_tiers', 'self_signup_tiers'],
            },
            {
              to: `${ROUTE_REDESIGN}${ROUTE_SETTINGS_CAPSULES}`,
              title: 'Capsules',
              Icon: <CapsuleIcon />,
              restrictedTiers: [],
              featureFlagKey: 'UI_ENABLE_CAPSULES_SETTINGS',
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/authentication`,
              title: 'Authentication',
              Icon: <ShieldCheckIcon />,
              restrictedTiers: ['express_tiers'],
            },
            getFeatureFlagValue('UI_ENABLE_SDK_APPLICATIONS') && {
              to: `${PATHS.ROUTE_REDESIGN}/settings/sdk-applications`,
              title: 'SDK Applications',
              Icon: <AppsAddIcon />,
              restrictedTiers: ['express_tiers'],
            },
            {
              to: `${PATHS.ROUTE_REDESIGN}/settings/app-integrations`,
              title: 'App Integrations',
              Icon: <ThirdPartyIntegrationsIcon />,
              restrictedTiers: ['express_tiers'],
            },
          ],
        },
        isDemo
          ? {
              name: 'BILLING SETTINGS',
              badge: 'Coming Soon',
              restrictedTiers: [],
              items: [
                {
                  title: 'Subscription plan',
                  Icon: <LayersIcon />,
                  restrictedTiers: [],
                },
                {
                  title: 'Billing information',
                  Icon: <NoteBookIcon />,
                  restrictedTiers: [],
                },
                {
                  title: 'Payment history',
                  Icon: <ReceiptIcon />,
                  restrictedTiers: [],
                },
              ],
            }
          : null,
        user.super_user && !impersonated
          ? {
              name: 'OTHERS',
              restrictedTiers: ['express_tiers'],
              items: [
                {
                  to: `${PATHS.ROUTE_REDESIGN}/settings/customer-orgs`,
                  title: 'Customer orgs',
                  Icon: <CustomerOrgsIcon sx={{ width: 16, height: 16, color: '#2F3037' }} />,
                  restrictedTiers: [],
                },
                {
                  to: `${PATHS.ROUTE_REDESIGN}/settings/plan-tiers`,
                  title: 'Plan tiers',
                  Icon: <PlanTiersIcon sx={{ width: 16, height: 16, color: '#2F3037' }} />,
                  restrictedTiers: [],
                },
                {
                  to: `${PATHS.ROUTE_REDESIGN}/settings/impersonation`,
                  title: 'Impersonation',
                  Icon: <IncognitoIcon />,
                  restrictedTiers: [],
                },
                {
                  to: `${PATHS.ROUTE_REDESIGN}/settings/connector-builder`,
                  title: 'Connector Builder',
                  Icon: <PuzzleIcon />,
                  restrictedTiers: [],
                },
              ],
            }
          : null,
      ];
    },
  },
];

export default structure;
